import { BehaviorSubject, Observable, tap } from 'rxjs'
import { useState, useEffect } from 'react'

export function useLocalState<T>(state$: BehaviorSubject<T> | Observable<T>, initValue: T, map?: (s: T) => T) {
  const [state, setState] = useState<T>(map ? map(initValue) : initValue)
  useEffect(() => {
    const sub = state$.pipe(tap((s) => setState(map ? map(s) : s))).subscribe()
    return () => {
      sub.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return state
}
